import { useState } from "react";
import { Link } from "react-router-dom";
import { IconMenu } from "./icons";
import MobileNavDrawer from "./MobileNavDrawer";
import ResponsiveNav from "./ResponsiveNav";
import styles from "./SiteHeader.module.css";

export default function SiteHeader({ logo, navItems, utilityItems, onSearch }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [navOverflows, setNavOverflows] = useState(false);

  // Drawer surfaces both nav + utility actions; the desktop header
  // continues to render utility on the right as before.
  const drawerUtility = (utilityItems || []).filter(
    (u) => typeof u !== "string"
  );

  return (
    <header className={styles.header}>
      <button
        type="button"
        className={[styles.menuBtn, navOverflows ? styles.menuBtnForce : ""].join(" ")}
        onClick={() => setDrawerOpen(true)}
        aria-label="Open menu"
      >
        <IconMenu />
      </button>

      <Link className={styles.logo} to="/">
        {logo}
      </Link>

      <ResponsiveNav items={navItems} onOverflow={setNavOverflows} />

      <div className={styles.utility}>
        {utilityItems.map((item) => {
          if (typeof item === "string") {
            return <span key={item} className={styles.utilityItem}>{item}</span>;
          }
          if (item.onClick) {
            return (
              <button
                key={item.label}
                type="button"
                className={styles.utilityItem}
                onClick={item.onClick}
              >
                {item.label}
              </button>
            );
          }
          if (item.path) {
            return (
              <Link key={item.label} to={item.path} className={styles.utilityItem}>
                {item.label}
              </Link>
            );
          }
          if (item.href) {
            return (
              <a key={item.label} href={item.href} className={styles.utilityItem} rel="noopener">
                {item.label}
              </a>
            );
          }
          return (
            <span key={item.label} className={styles.utilityItem}>
              {item.label}
            </span>
          );
        })}
      </div>

      <MobileNavDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        navItems={navItems}
        utilityItems={drawerUtility}
        onSearch={onSearch}
      />
    </header>
  );
}
